<template>
  <div id="app">

    <!-- Pages without sidebar and navbar -->
    <div v-if="hideNavigation">
      <div>
        <router-view/>
      </div>
    </div>

    <!-- Pages with sidebar and navbar -->
    <div v-else>

      <div class="row no-gutters">

      <div class="d-none d-md-block col-md-3 col-lg-2">

        <div id="sidebar" ref="sidebar">
          <div id="sidebar-header">
            <img class="sidebar-header-logo" :src="require(`@/assets/images/b122/logo.png`)" alt="Logo Clinique des NAC">
          </div>

          <b-nav vertical class="sidebar-list">
            <SideMenu
              :links="sidebarLinks"
              :underlinks="sideBarUnderlinks"
            ></SideMenu>
          </b-nav>
        </div>
      </div>

      <div class="col-12 col-md-9 col-lg-10">

        <b-navbar toggleable="md">

          <b-navbar-brand>
            <div class="d-md-none">
              <img class="sidebar-header-logo" :src="require(`@/assets/images/b122/logo.png`)" alt="Logo Clinique des NAC">
            </div>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>

            <b-navbar-nav>
              <NavBarMenu
                :links="sidebarLinks"
                :underlinks="sideBarUnderlinks"
              ></NavBarMenu>
              <b-nav-item class="d-md-none" @click="showMyAccountModal">Mot de passe</b-nav-item>
              <b-nav-item class="d-md-none" @click="logout">Déconnexion</b-nav-item>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto d-none d-md-block">

              <b-nav-item-dropdown right>
                <!-- Using 'button-content' slot -->
                <template #button-content>
                  {{ $store.getters.username }}
                </template>
                <b-dropdown-item @click="showMyAccountModal">
                  Mot de passe
                </b-dropdown-item>
                <b-dropdown-item @click="logout">
                  Déconnexion
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>

        <div class="page-container">
          <router-view class="content-wrap"/>
          <div class="main-footer" >
            <p>Copyright © 2022 CLINIQUE DES NAC.
              <span style="white-space: nowrap;">All rights reserved.</span>
            </p>
            <p style="white-space: nowrap;">Made with <heart-icon class="text-danger"/> by <a href="https://www.bleu122.com/">Bleu122</a></p>
          </div>

        </div>

      </div>

    </div>
  </div>

  <!-- Modal My Account -->
  <my-account-modal></my-account-modal>

</div>
</template>

<script>

import MyAccountModal from './views/user/MyAccountModal'
import SideMenu from './views/menus/SideMenu'
import NavBarMenu from './views/menus/NavBarMenu'

export default {

  name: 'App',

  data: function () {
    return {
      sidebarLinks: [
        {
          'icon': 'stethoscope-icon',
          'title': 'Hospitalisations',
          'route': '/',
          'activeOn': ['/', '/hospitalization/show', '/hospitalization/edit', '/hospitalization/create', '/dailyStatus/create', '/dailyStatus/edit', '/dailyStatus/show', '/surgery/forHospitalization', '/note/forHospitalization'],
          'isExpendable': false
        },
        {
          'icon': 'vaccine-icon',
          'title': 'Chirurgies',
          'route': '',
          'activeOn': [],
          'isExpendable': true,
          'expendableId': 'navbar-toggle-surgeries',
          'underlinksIndex': 0
        },
        {
          'icon': 'building-hospital-icon',
          'title': 'La Clinique',
          'route': '',
          'activeOn': [],
          'isExpendable': true,
          'expendableId': 'navbar-toggle-clinic',
          'underlinksIndex': 1
        },
        {
          'icon': 'notes-icon',
          'title': 'Notes',
          'route': '/note/index',
          'activeOn': ['/note/index', '/note/show', '/note/create', '/note/edit'],
          'isExpendable': false
        },
        {
          'icon': 'archive-icon',
          'title': 'Archives',
          'route': '',
          'activeOn': [],
          'isExpendable': true,
          'expendableId': 'navbar-toggle-history',
          'underlinksIndex': 3
        },
        {
          'icon': 'tools-icon',
          'title': 'Données',
          'route': '',
          'activeOn': [],
          'isExpendable': true,
          'expendableId': 'navbar-toggle-data',
          'underlinksIndex': 2
        }
      ],
      sideBarUnderlinks: [
        [
          {
            'title': 'Liste des chirurgies',
            'route': '/surgery/index',
            'activeOn': ['/surgery/index', '/surgery/show', '/surgery/edit', '/surgery/create']
          },
          {
            'title': 'Modèles compte-rendu',
            'route': '/surgeryTemplate/index',
            'activeOn': ['/surgeryTemplate/index', '/surgeryTemplate/show', '/surgeryTemplate/create', '/surgeryTemplate/edit']
          }
        ],
        [
          {
            'title': 'Liste des animaux',
            'route': '/animal/index',
            'activeOn': ['/animal/index', '/animal/show', '/animal/create', '/animal/edit']
          },
          {
            'title': 'Liste des propriétaires',
            'route': '/user/index',
            'activeOn': ['/user/index', '/user/show', '/user/create', '/user/edit']
          }
        ],
        [
          {
            'title': 'Espèces',
            'route': '/species/index',
            'activeOn': ['/species/index', '/species/show', '/species/create', '/species/edit']
          },
          {
            'title': 'Familles',
            'route': '/family/index',
            'activeOn': ['/family/index', '/family/show', '/family/create', '/family/edit']
          },
          {
            'title': 'États de santé',
            'route': '/healthState/index',
            'activeOn': ['/healthState/index', '/healthState/show', '/healthState/create', '/healthState/edit']
          },
          {
            'title': 'Aliments',
            'route': '/food/index',
            'activeOn': ['/food/index', '/food/show', '/food/create', '/food/edit']
          },
          {
            'title': 'Transits',
            'route': '/transit/index',
            'activeOn': ['/transit/index', '/transit/show', '/transit/create', '/transit/edit']
          }
        ],
        [
          {
            'title': 'Hospitalisations',
            'route': '/hospitalizationArchive/index',
            'activeOn': ['/hospitalizationArchive/index']
          },
          {
            'title': 'Chirurgies',
            'route': '/surgeryArchive/index',
            'activeOn': ['/surgeryArchive/index']
          },
          {
            'title': 'Notes',
            'route': '/noteArchive/index',
            'activeOn': ['/noteArchive/index']
          }
        ]
      ]
    }
  },

  components: {
    MyAccountModal,
    SideMenu,
    NavBarMenu
  },

  computed: {
    hideNavigation () {
      return !this.$store.getters.isAuthenticated
    }
  },

  methods: {
    async logout () {
      await this.$store.dispatch('LogOut')
      this.$router.push('/login')
    },

    showMyAccountModal () {
      this.$bvModal.show('my-account-modal')
    }

  }
}
</script>

<style scoped>
  #sidebar {
    position: relative;
    height: 100%;
    min-height: 100vh;
    padding-top: 20px;
    background-color: var(--main-white);
    top: 0;
    z-index: 2;
    box-shadow: 3px 0 5px rgba(0,0,0,0.15);
  }
  #sidebar-header{
    display: flex;
    justify-content: center;
  }
  .sidebar-header-logo {
    width: 70%;
  }
  .sidebar-list {
    margin-top: 1em;
  }

  .main-footer{
    position: absolute;
    bottom: 0;
    width: 80vw;
    height: 3rem;
    display: flex;
    justify-content: space-between;
    margin: 0 2%;
    padding-top: 10px;
    border-top: 1px solid var(--neutral-300);
  }
  .page-container{
    position: relative;
    min-height: 87vh;
  }
  .content-wrap {
    padding-bottom: 3rem;    /* Footer height */
  }

  @media only screen and (max-width: 991px) and (min-width: 768px) {
    .main-footer{
      width: 70vw;
      height: 3.5rem;
    }
    .content-wrap {
      padding-bottom: 3.5rem;    /* Footer height */
    }
  }
  @media only screen and (max-width: 767px) {
    .navbar{
      align-items: start;
    }
    .sidebar-header-logo {
      width: 100px;
    }
    .main-footer{
      width: 92vw;
      font-size: 12px;
      height: 3.5rem;
    }
    .content-wrap {
      padding-bottom: 3.5rem;    /* Footer height */
    }
    .page-container{
      min-height: 82vh;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue